import { render, staticRenderFns } from "./AccountBanksEdit.vue?vue&type=template&id=03f04152&scoped=true"
import script from "./AccountBanksEdit.vue?vue&type=script&lang=js"
export * from "./AccountBanksEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f04152",
  null
  
)

export default component.exports